import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import Modal from 'react-modal'
import config from '../../config'
import format from '../../helpers/format'
import {
  FinanceCompanyScore,
  Link,
} from '../'
import Styles from './FinanceCompanyProfileModal.css'

@CSSModules(Styles, {allowMultiple: true})
export default class FinanceCompanyProfileModal extends Component {
  static propTypes = {
    holding: PropTypes.object.isRequired,
    fundholding: PropTypes.object.isRequired,
  }

  constructor(props){
    super(props);
    this.state = {
      holding: props.holding,
      fundholding: props.fundholding,
      modalOpen: false
    }
  }

  openModal = () =>{
    this.setState({ modalOpen: true })
  }

  closeModal = () =>{
    this.setState({ modalOpen: false })
  }

  render() {
    const { holding, fundholding } = this.state
    if (!holding || !fundholding) { return null }
    const weight = fundholding.long_weight

    // bank details logic
    const isBank = holding.is_fossil_bank
    let lendingAmount = null
    let bankScore = null
    let bankScoreContribution = null
    if (isBank) {
      lendingAmount = format.money(
        holding.fossil_bank_lending_total,
        true,
        'USD',
        true
      )
      bankScore = format.number(holding.fossil_bank_score, false, false, 1)
      bankScoreContribution = format.number(weight * holding.fossil_bank_score * 100, false, false, 1)
      bankScoreContribution = bankScoreContribution === '0.0' ? '<0.1' : bankScoreContribution
    }

    // insurer details logic
    const isInsure = holding.is_fossil_insure
    let insureScore = null
    let insureScoreContribution = null
    if (isInsure) {
      insureScore = format.number(holding.fossil_insure_score, false, false, 1)
      insureScoreContribution = format.number(weight * holding.fossil_insure_score * 100, false, false, 1)
      insureScoreContribution = insureScoreContribution === '0.0' ? '<0.1' : insureScoreContribution
    }

    // policies
    const coal_policies = config.coalPolicyTool[holding.company_id]
    const oil_gas_policies = config.oilGasPolicyTracker[holding.company_id]

    const indicator0 = require('../../../static/images/ic_pastille_0.png')
    const indicator1 = require('../../../static/images/ic_pastille_1.png')
    const indicator2 = require('../../../static/images/ic_pastille_2.png')
    const indicator3 = require('../../../static/images/ic_pastille_3.png')
    const indicator4 = require('../../../static/images/ic_pastille_4.png')

    const policy_mapper_fn = (x) => {
      let result = null
      switch (x) {
        case -2:
          result = 'NA'
          break
        case -1:
          result = 'Not found'
          break
        default:
          result = x
          break
      }
      return result
    }

    const indicator_mapper_fn = (x) => {
      let result = null
      switch (x) {
        case -2:
          result = 'NA'
          break
        case -1:
          result = 'Not found'
          break
        case 0:
          result = (<img src={indicator0} alt='No exclusion policy'
                      title='No exclusion policy'/>)
          break
        case 1:
          result = (<img src={indicator1} alt='Very weak exclusion policy'
                      title='Very weak exclusion policy'/>)
          break
        case 2:
          result = (<img src={indicator2} alt='Weak exclusion policy'
                      title='Weak exclusion policy'/>)
          break
        case 3:
          result = (<img src={indicator3} alt='Comprehensive exclusion policy'
                      title='Comprehensive exclusion policy'/>)
          break
        case 4:
          result = (<img src={indicator4} alt='Robust exclusion policy'
                      title='Robust exclusion policy'/>)
          break
        default:
          result = 'ERROR'
          break
      }
      return result
    }


    let coal_policies_mapped = null
    let oil_gas_policies_mapped = null
    let oil_gas_indicators_mapped = null
    if (coal_policies) {
      coal_policies_mapped = coal_policies.map(x => policy_mapper_fn(x))
    }
    if (oil_gas_policies) {
      oil_gas_policies_mapped = oil_gas_policies.slice(0, 3).map(x => policy_mapper_fn(x))
      oil_gas_indicators_mapped = oil_gas_policies.slice(3, oil_gas_policies.length).map(x => indicator_mapper_fn(x))
    }


    //
    return (
      <span>
        <span onClick={this.openModal} styleName='modal-opener'>
          {this.props.children}
        </span>

        <Modal
          isOpen={this.state.modalOpen}
          onRequestClose={this.closeModal}
          contentLabel="This fund is managed by"
          style={{
            overlay : {
              backgroundColor   : 'rgba(0, 0, 0, 0.75)',
              zIndex: '999999'
            },
            content: {
              position                   : 'absolute',
              left                       : 0,
              right                      : 0,
              marginLeft                 : 'auto',
              marginRight                : 'auto',
              borderRadius               : 0,
              width                      : '900px',
              maxWidth                   : '90%',
              top                        : '50%',
              border                     : '0px',
              background                 : '#fff',
              overflow                   : 'visible',
              bottom                     : 'auto',
              WebkitOverflowScrolling    : 'touch',
              outline                    : 'none',
              transform                  : 'translateY(-50%)',
              padding                    : 0,
              maxHeight                  : '80%',
              overflowY                  : 'auto',
            }
          }}>
          <div styleName='family-modal-wrap'>
            <div styleName='family-modal'>

              { /* HEADER (COMPANY NAME) */ }
              <h1 styleName='family-modal-header'>
                {holding.security_name}
              </h1>

              <div styleName='family-modal-data-row'>
                <div styleName='family-modal-data-row-header'>
                  <h2>
                    { isBank ? 'Finance' : 'Insurance' } score
                  </h2>

                  {
                    isBank ?
                      <p styleName='family-modal-data-row-header-source'>
                        Source: <Link
                          to='https://www.bankingonclimatechaos.org/'
                          title='Banking on Climate Chaos'
                          xstrong
                        >
                          Banking on Climate Chaos
                        </Link>
                      </p> :
                      <p styleName='family-modal-data-row-header-source'>
                        Source: <Link
                          to='https://us.insure-our-future.com/wp-content/uploads/2024/12/IoF-Scorecard-2024.pdf'
                          title='Insure Our Future Scorecard'
                          xstrong
                        >
                          Insure Our Future
                        </Link>
                      </p>
                  }
                </div>

                { /*
                    ____          _   _ _  __ _____
                   |  _ \   /\   | \ | | |/ // ____|
                   | |_) | /  \  |  \| | ' /| (___
                   |  _ < / /\ \ | . ` |  <  \___ \
                   | |_) / ____ \| |\  | . \ ____) |
                   |____/_/    \_\_| \_|_|\_\_____/

                */ }
                {
                  isBank ?
                    <div styleName='modal-flex-row'>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Total financing
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Lending & underwriting of debt/equity
                              issuances to fossil fuels, 2016-2023
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            <strong>{lendingAmount}</strong>
                          </div>
                        </div>
                      </div>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Company risk score
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Total financing normalized 0-10 (10 is worst)
                              <br/>
                              <Link
                                to={config.routes.banksInsurance + '#methodology-fossil-fuel-finance'}
                                title='Methodology'
                                xstrong
                              >
                                Methodology
                              </Link>
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            <FinanceCompanyScore score={bankScore} large/>
                          </div>
                        </div>
                      </div>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Fund score contribution
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Company risk score x holding weight
                              <br/>
                              <Link
                                to={config.routes.banksInsurance + '#methodology-fossil-fuel-finance'}
                                title='Methodology'
                                xstrong
                              >
                                Methodology
                              </Link>
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            <strong>{bankScore} x {format.perc(weight)} = {bankScoreContribution}</strong>
                          </div>
                        </div>
                      </div>
                    </div> :
                    null
                }

                { /*
                  _____ _   _  _____ _    _ _____  ______ _____   _____
                 |_   _| \ | |/ ____| |  | |  __ \|  ____|  __ \ / ____|
                   | | |  \| | (___ | |  | | |__) | |__  | |__) | (___
                   | | | . ` |\___ \| |  | |  _  /|  __| |  _  / \___ \
                  _| |_| |\  |____) | |__| | | \ \| |____| | \ \ ____) |
                 |_____|_| \_|_____/ \____/|_|  \_\______|_|  \_\_____/

                */ }
                {
                  isInsure ?
                    <div styleName='modal-flex-row'>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Company risk score
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Fossil fuel insurance policy score, normalized 0-10 (10 is worst)
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            <FinanceCompanyScore score={insureScore} large/>
                          </div>
                        </div>
                      </div>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Fund score contribution
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Company risk score x holding weight
                              <br/>
                              <Link
                                to={config.routes.banksInsurance + '#methodology-fossil-fuel-insurance'}
                                title='Methodology'
                                xstrong
                              >
                                Methodology
                              </Link>
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            <strong>{insureScore} * {format.perc(weight)} = {insureScoreContribution}</strong>
                          </div>
                        </div>
                      </div>
                    </div> :
                    null
                }

              </div>


              { /*
                _____   ____  _      _____ _____ _____ ______  _____
               |  __ \ / __ \| |    |_   _/ ____|_   _|  ____|/ ____|
               | |__) | |  | | |      | || |      | | | |__  | (___
               |  ___/| |  | | |      | || |      | | |  __|  \___ \
               | |    | |__| | |____ _| || |____ _| |_| |____ ____) |
               |_|     \____/|______|_____\_____|_____|______|_____/

              */ }
              
              { /*
              <div styleName='family-modal-data-row'>

                <div styleName='family-modal-data-row-header'>
                  <h2>
                    Coal policy scores
                  </h2>

                  <p styleName='family-modal-data-row-header-source'>
                    Source: <Link
                      to='https://coalpolicytool.org/'
                      title='Coal policy tool - Reclaim Finance'
                      xstrong
                    >
                      coalpolicytool.org
                    </Link>
                  </p>
                </div>

                {
                  coal_policies_mapped ?
                    <div styleName='modal-flex-row'>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Projects
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion of coal mines, coal plants, and coal infrastructure projects (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+coal_policies[0]}>
                            {coal_policies_mapped[0]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Developers
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion of coal companies developing new coal projects (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+coal_policies[1]}>
                            {coal_policies_mapped[1]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Relative threshold
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion of coal companies based on their coal share of revenue/power generation (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+coal_policies[2]}>
                            {coal_policies_mapped[2]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Absolute threshold
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion of coal companies based on their annual thermal coal production or their coal capacity (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+coal_policies[3]}>
                            {coal_policies_mapped[3]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Phase-out
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Quality of coal phase-out commitments (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+coal_policies[4]}>
                            {coal_policies_mapped[4]}
                          </div>
                        </div>
                      </div>

                    </div> :
                    <div styleName='no-data-disclaimer'>
                      No data for this company
                    </div>
                }
              </div>

              <div styleName='family-modal-data-row'>
                <div styleName='family-modal-data-row-header'>
                  <h2>
                    Oil/gas policy scores
                  </h2>

                  <p styleName='family-modal-data-row-header-source'>
                    Source: <Link
                      to='https://oilgaspolicytracker.org/'
                      title='Oil/gas policy tracker - Reclaim Finance'
                      xstrong
                    >
                      oilgaspolicytracker.org
                    </Link>
                  </p>
                </div>

                {
                  oil_gas_policies_mapped ?
                    <div styleName='modal-flex-row'>
                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Projects
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Immediate exclusion of oil and gas projects (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+oil_gas_policies[0]}>
                            {oil_gas_policies_mapped[0]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Expansion
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion of companies with oil and gas expansion plans (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+oil_gas_policies[1]}>
                            {oil_gas_policies_mapped[1]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Phase-out
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Quality of oil and gas phase-out commitments (10 is best)
                            </p>
                          </div>
                          <div styleName={'modal-cell-value-'+oil_gas_policies[2]}>
                            {oil_gas_policies_mapped[2]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Arctic
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion policy for sector
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            {oil_gas_indicators_mapped[0]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Fracking
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion policy for sector
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            {oil_gas_indicators_mapped[1]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Tar sands
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion policy for sector
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            {oil_gas_indicators_mapped[2]}
                          </div>
                        </div>
                      </div>

                      <div styleName='modal-flex-col'>
                        <div styleName='modal-cell'>
                          <div styleName='modal-cell-label'>
                            <h3>
                              Ultra deep water
                            </h3>
                            <p styleName='modal-cell-label-info'>
                              Exclusion policy for sector
                            </p>
                          </div>
                          <div styleName='modal-cell-value'>
                            {oil_gas_indicators_mapped[3]}
                          </div>
                        </div>
                      </div>

                    </div> :
                    <div styleName='no-data-disclaimer'>
                      No data for this company
                    </div>
                }
              </div>
              */ }

            </div>
          </div>

          { /* CLOSE MODAL */ }
          <div styleName='family-modal-close-wrap' onClick={ this.closeModal }>
            <div styleName='family-modal-close' className='fa fa-times'></div>
          </div>

        </Modal>
      </span>
    )
  }
}

